import React from "react";
import Steps from "./Steps";
import axios from "axios";
import { ClipLoader } from "react-spinners";

function CompanyDetailsForm4({ setIsOTPPopupVisible, setFormData, userEmail, setFormNum, formData, loading }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const requiredFields = ['full_name', 'email', 'region', 'country', 'zipcode', 'address', 'prime_category', 'website'];
    const missingFields = requiredFields.filter(
      field => !formData?.[field] || formData[field].trim() === ''
    );
    if (missingFields.length > 0) {
      alert(`Please fill all required fields: ${missingFields.join(', ')}`);
      return;
    }
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("myotp", "sendotp");
      formDataToSend.append("user_email", userEmail);
      // console.log(userEmail);
      const response = await axios.post(
        "/api/getotp.php",
        formDataToSend
      );
      if (response.data?.OTP) {
        // console.log("OTP Received:", response.data.OTP);w
        setIsOTPPopupVisible(true);
      } else {
        console.error("Error: OTP not received");
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleBackClick = () => {
    setFormNum((prev) => prev - 1);
  }
  
  return (
    <div className="flex justify-center items-center font-inter">
      {loading && (
        <div className="fixed inset-0 flex justify-center items-center z-50 bg-white bg-opacity-75">
          <ClipLoader color="#006b4f" size={35} speedMultiplier={1} />
        </div>
      )}
      <div className="w-full max-w-lg xl:max-w-2xl bg-white p-4 sm:px-0">
        <form onSubmit={handleSubmit}>
          <div>
            <Steps stepNum={4} setFormNum={setFormNum}/>
            <h2 className="text-xl md:text-2xl 2xl:text-3xl 2xl:mb-4 2xl:ml-1 font-semibold text-[#111827] my-4">
              Additional Office
            </h2>
          </div>
          <div className="w-full">
            <input
              type="text"
              id="region"
              name="region2"
              value={formData.region2}
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] text-[#5F5F5F] rounded-lg"
              placeholder="Region"
              onChange={handleChange}
            />
          </div>
          <div className="w-full">
            <input
              type="text"
              id="country"
              name="country2"
              value={formData.country2}
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] text-[#5F5F5F] rounded-lg"
              placeholder="Country"
              onChange={handleChange}
            />
          </div>
          <div className="w-full">
            <input
              type="text"
              id="address"
              name="address2"
              value={formData.address2}
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] text-[#5F5F5F] rounded-lg"
              placeholder="Address"
              onChange={handleChange}
            />
          </div>
          <div className="w-full">
            <input
              type="text"
              id="zipcode"
              name="zipcode2"
              value={formData.zipcode2}
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] text-[#5F5F5F] rounded-lg"
              placeholder="ZipCode"
              onChange={handleChange}
            />
          </div>
          <div className="w-full">
            <input
              type="text"
              id="phone"
              name="phone2"
              value={formData.phone2}
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] text-[#5F5F5F] rounded-lg"
              placeholder="Phone"
              onChange={handleChange}
            />
          </div>
          <div className="w-full">
            <input
              type="email"
              id="email"
              name="email2"
              value={formData.email2}
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] text-[#5F5F5F] rounded-lg"
              placeholder="E-mail"
              onChange={handleChange}
            />
          </div>
          <div className="w-full">
            <input
              type="text"
              id="website"
              name="website2"
              value={formData.website2}
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg mb-4 border border-[#CAD0D9] text-[#5F5F5F] rounded-lg"
              placeholder="Website"
              onChange={handleChange}
              // onKeyDown={(e) => e.key === 'Enter' && setIsOTPPopupVisible(true)}
            />
          </div>
          <div className="flex justify-between gap-4">
            <button
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg 2xl:mb-4 text-white bg-[#5D5D5D] rounded-lg hover:bg-[#4B4B4B] transition-colors"
              type="submit"
              onClick={handleBackClick}
            >
              Back
            </button>
            <button
              className="w-full px-4 py-2 2xl:py-3 2xl:text-lg 2xl:mb-4 text-white bg-[#5D5D5D] rounded-lg hover:bg-[#4B4B4B] transition-colors"
              type="submit"
            >
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CompanyDetailsForm4;